import t from "../../../../helpers/t";
import React from "react";

const FkModelInput = (props) => {
  let task = props["task"];
  let userObjectState = props["userObjectState"];
  let linkedUser = props["linkedUser"];
  let setUserObjectState = props["setUserObjectState"];
  let queryUserObjectSelectHandle = props["queryUserObjectSelectHandle"];
  let userObjectSelectHandle = props["userObjectSelectHandle"];
  let _usersResults = props["_usersResults"];
  let resourceObjectState = props["resourceObjectState"];
  let resource = props.resource;
  let setResourceObjectState = props["setResourceObjectState"];
  let queryResourceObjectSelectHandle = props["queryResourceObjectSelectHandle"];
  let resourceObjectSelectHandle = props["resourceObjectSelectHandle"];
  let _resourcesResults = props["_resourcesResults"];
  let orderStatus = props["orderStatus"];
  let onChangeForm = props.onChangeForm;

  return (
    <>
      <div className="inb-form__controllClass">
        {task.fk_model === "Users" && (
          <div
            className={"inbooma-select-box" + (userObjectState.isOpen ? "" : " close")}
            style={{ zIndex: "0" }}
          >
            <input
              readOnly={task.readonly}
              className="inbooma-select-box__input"
              placeholder={t("add_existing_user")}
              value={
                linkedUser == null
                  ? userObjectState.value
                  : props.getUserNameById(
                      linkedUser,
                      true,
                      props.userQueue,
                      props.setUserQueue,
                      props.extraUsers,
                    )
              }
              style={
                linkedUser !== undefined && linkedUser != null && !task.readonly
                  ? {
                      background: "#fff",
                      border: "1px solid #e3e3e3",
                      padding: "0.5rem",
                      fontSize: "0.9rem",
                      color: "#3b3b3b",
                    }
                  : {}
              }
              onClick={
                task.readonly
                  ? () => {}
                  : () => {
                      setUserObjectState({ ...userObjectState, isOpen: true });
                    }
              }
              onBlur={
                task.readonly
                  ? () => {}
                  : () => {
                      setUserObjectState({ ...userObjectState, isOpen: false });
                    }
              }
              onChange={
                task.readonly
                  ? () => {}
                  : (e) => {
                      queryUserObjectSelectHandle(e);
                    }
              }
            />
            {linkedUser !== undefined && linkedUser != null && !task.readonly && (
              <a
                href="#"
                className="inbooma-select-box__reset"
                onClick={() => userObjectSelectHandle(null)}
              >
                x
              </a>
            )}
            {_usersResults.success === true && !task.readonly && (
              <ul
                className={"inbooma-select-box-results" + (userObjectState.isOpen ? "" : " hidden")}
              >
                {_usersResults.data.map((user) => {
                  return (
                    <li
                      className={
                        "inbooma-select-box-results__field" +
                        (linkedUser === user.id ? " selected" : "")
                      }
                      value={user.id}
                      onClick={() => {
                        userObjectSelectHandle(user);
                      }}
                    >
                      {user.first_name + " " + user.last_name}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        )}
        {task.fk_model === "Resources" && (
          <div
            className={"inbooma-select-box" + (resourceObjectState.isOpen ? "" : " close")}
            style={{ zIndex: "0" }}
          >
            <input
              readOnly={task.readonly}
              className="inbooma-select-box__input"
              placeholder={t("add_existing_resource")}
              value={resource == null ? resourceObjectState.value : resource}
              style={
                resource !== undefined && resource != null && !task.readonly
                  ? {
                      background: "#fff",
                      border: "1px solid #e3e3e3",
                      padding: "0.5rem",
                      fontSize: "0.9rem",
                      color: "#3b3b3b",
                    }
                  : {}
              }
              onClick={
                task.readonly
                  ? () => {}
                  : () => {
                      setResourceObjectState({ ...resourceObjectState, isOpen: true });
                    }
              }
              onBlur={
                task.readonly
                  ? () => {}
                  : () => {
                      setResourceObjectState({ ...resourceObjectState, isOpen: false });
                    }
              }
              onChange={
                task.readonly
                  ? () => {}
                  : (e) => {
                      queryResourceObjectSelectHandle(e);
                    }
              }
            />
            {resource !== undefined && resource != null && !task.readonly && (
              <a
                href="#"
                className="inbooma-select-box__reset"
                onClick={() => resourceObjectSelectHandle(null)}
                style={{ float: "unset" }}
              >
                x
              </a>
            )}
            {_resourcesResults.success === true && !task.readonly && (
              <ul
                className={
                  "inbooma-select-box-results" + (resourceObjectState.isOpen ? "" : " hidden")
                }
                style={{ width: "25rem" }}
              >
                <div className="inb-select-results-head">
                  <span id="select_sort_1" class="inb-select-sort-menu" style={{ width: "13rem" }}>
                    <a href="#" className="inb-select-box-sort">
                      ID
                    </a>
                  </span>
                  <span id="select_sort_4" class="inb-select-sort-menu" style={{ width: "8rem" }}>
                    <a href="#" className="inb-select-box-sort">
                      {" "}
                      {t("name", null, "capital")}
                    </a>
                  </span>
                  <span id="select_sort_5" class="inb-select-sort-menu" style={{ width: "4rem" }}>
                    <a href="#" className="inb-select-box-sort">
                      {" "}
                      {t("status", null, "capital")}
                    </a>
                  </span>
                </div>
                {_resourcesResults.data.map((res) => {
                  return (
                    <li
                      className={
                        "inbooma-select-box-results__field" +
                        (resource === res.id ? " selected" : "")
                      }
                      value={res.id}
                      onClick={() => {
                        resourceObjectSelectHandle(res);
                      }}
                    >
                      <span style={{ width: "13rem" }}>
                        {res.id}
                        <div
                          style={{
                            width: "1em",
                            height: "1px",
                            display: "inline-block",
                          }}
                        >
                          {" "}
                        </div>
                        {res.resource_nbr}
                        <div
                          style={{
                            width: "1em",
                            height: "1px",
                            display: "inline-block",
                          }}
                        >
                          {" "}
                        </div>
                        {res.external_resource_id}
                      </span>
                      <span style={{ width: "8rem", paddingRight: "5px" }}>{res.name}</span>
                      <span style={{ width: "4rem" }}>{res.status}</span>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        )}
        {task.fk_model === "Orders" && (
          <div className="inb-form__controllClass">
            <input
              readOnly={task.readonly}
              type="text"
              className="form-control"
              name="order_nbr"
              autoComplete="false"
              maxLength="255"
              value={orderStatus.number}
              onChange={(e) => onChangeForm(e)}
              placeholder=""
            />
          </div>
        )}
        {(task.fk_model === "Facilities" || task.fk_model === "") && (
          <select
            className="form-control "
            name="fk_id"
            value={task.fk_id}
            required=""
            onChange={onChangeForm}
            disabled={task.readonly}
            placeholder={t("add_existing_facility")}
          >
            <option> </option>
            {task.fk_model === "Facilities" &&
              props.facilities.map((facility) => {
                return (
                  <option value={facility.id}>
                    {facility.name !== null
                      ? facility.name
                      : t("facility", null, "capital") + " " + facility.id}
                  </option>
                );
              })}
          </select>
        )}
      </div>
    </>
  );
};

export default FkModelInput;
